// todo move this file to module
export let showPreFactorOptions = {
    '1': 'فعال',
    '0': 'غیرفعال',
}